/**
 * Not loaded. Do not add this script in layout/theme.liquid.
 * It cloned a Subscriptions item into the Skio nav. That inject is retired.
 */
(function () {
  if (window.__bbeSkioNavBound) return;
  window.__bbeSkioNavBound = true;

  var SUBS_PATH = '/a/account/subscriptions';
  var ORDERS_PREFIX = '/a/account/orders';
  var PROFILE_PREFIX = '/a/account/profile';

  function isSubscriptionsRoute() {
    var p = location.pathname;
    return p === SUBS_PATH || p.indexOf(SUBS_PATH + '/') === 0;
  }

  function isOrdersRoute() {
    return location.pathname.indexOf(ORDERS_PREFIX) === 0;
  }

  function isProfileRoute() {
    return location.pathname.indexOf(PROFILE_PREFIX) === 0;
  }

  function setNavActive(btn, active) {
    if (!btn) return;
    if (active) {
      btn.setAttribute('aria-current', 'page');
      btn.classList.add('bbe-skio-nav-active');
    } else {
      btn.removeAttribute('aria-current');
      btn.classList.remove('bbe-skio-nav-active');
    }
  }

  function markInactiveSubscription() {
    var inactive = !!document.querySelector(
      '#skio-root button[data-skio-name="generic-action-button-reactivate"], ' +
        '#skio-root button[data-skio-name*="reactivate-subscription" i], ' +
        '#skio-root [data-skio-name="subscription-card-reactivate-button"]'
    );
    document.documentElement.classList.toggle('bbe-skio-sub-inactive', inactive);
  }

  function ensureSubscriptionsNav() {
    var actions = document.querySelector('[data-skio-name="navbar-actions-container"]');
    if (!actions) return;

    var subsBtn = actions.querySelector('[data-skio-name="navbar-subscriptions-button"]');
    if (!subsBtn) {
      var template =
        actions.querySelector('[data-skio-name="navbar-orders-button"]') ||
        actions.querySelector('[data-skio-name="navbar-profile-button"]') ||
        actions.querySelector('[data-skio-name="navbar-logout-button"]');
      if (!template) return;

      subsBtn = template.cloneNode(true);
      subsBtn.setAttribute('data-skio-name', 'navbar-subscriptions-button');
      subsBtn.removeAttribute('id');
      var text = subsBtn.querySelector('[data-text]');
      if (text) text.textContent = 'Subscriptions';
      else subsBtn.textContent = 'Subscriptions';
      subsBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!isSubscriptionsRoute()) window.location.href = SUBS_PATH;
      });
      actions.insertBefore(subsBtn, actions.firstElementChild);
    }

    var ordersBtn = actions.querySelector('[data-skio-name="navbar-orders-button"]');

    setNavActive(
      actions.querySelector('[data-skio-name="navbar-subscriptions-button"]'),
      isSubscriptionsRoute()
    );
    setNavActive(actions.querySelector('[data-skio-name="navbar-orders-button"]'), isOrdersRoute());
    setNavActive(actions.querySelector('[data-skio-name="navbar-profile-button"]'), isProfileRoute());
    markInactiveSubscription();
  }

  function tick() {
    try {
      ensureSubscriptionsNav();
    } catch (e) {}
  }

  tick();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  }
  setTimeout(tick, 400);
  setTimeout(tick, 1200);

  var t = null;
  var mo = new MutationObserver(function () {
    if (t) clearTimeout(t);
    t = setTimeout(tick, 100);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('popstate', tick);
  setInterval(tick, 3000);
})();
